import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=a58e6a72&scoped=true"
import script from "./Sample.vue?vue&type=script&lang=js"
export * from "./Sample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58e6a72",
  null
  
)

export default component.exports